import pclnExperimentation from '@pcln/experimentation'
import { useCallback, useRef } from 'react'

import { HTL_TYPEAHEAD_POPULAR_TRENDING_EXPERIMENT } from './constants/popularTrending'

/**
 * Returns a callback that fires the hotel popular/trending experiment impression
 * at most once per mount. Shared by the legacy TypeAhead and the Horizon
 * AutocompleteWrapper so both dedup identically — reopening the dropdown must not
 * inflate impression counts. Non-hotel typeaheads never fire.
 */
export function usePopularTrendingImpression(isHotelTypeahead: boolean): () => void {
  const didFire = useRef(false)

  return useCallback(() => {
    if (isHotelTypeahead && !didFire.current) {
      didFire.current = true
      pclnExperimentation.fireImpression(HTL_TYPEAHEAD_POPULAR_TRENDING_EXPERIMENT)
    }
  }, [isHotelTypeahead])
}
